import React from "react";

const chaklMarks = [
  { symbol: "َ", name: "Fatha", description: "Short A sound (e.g. 'ba')" },
  { symbol: "ِ", name: "Kasra", description: "Short I sound (e.g. 'bi')" },
  { symbol: "ُ", name: "Damma", description: "Short U sound (e.g. 'bu')" },
  { symbol: "ً", name: "Tanween Fath", description: "An sound (e.g. 'ban')" },
  { symbol: "ٍ", name: "Tanween Kasr", description: "In sound (e.g. 'bin')" },
  { symbol: "ٌ", name: "Tanween Damm", description: "Un sound (e.g. 'bun')" },
  { symbol: "ْ", name: "Sukoon", description: "No vowel (e.g. 'ab')" },
  { symbol: "ّ", name: "Shadda", description: "Double consonant (e.g. 'abb')" },
];

function ChaklLesson() {
  const speak = (text) => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(text, "Arabic Male");
    }
  };

  return (
    <div className="p-6 md:p-10">
      <h2 className="text-3xl font-bold text-center text-blue-700 mb-6">Chakl (Tashkeel) - Arabic Diacritical Marks</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {chaklMarks.map((mark, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition text-center"
          >
            <div
              className="text-5xl text-blue-700 mb-2 cursor-pointer"
              onClick={() => speak(mark.symbol)}
            >
              {mark.symbol}
            </div>
            <h3 className="text-xl font-semibold text-blue-800">{mark.name}</h3>
            <p className="text-gray-600">{mark.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChaklLesson;
